
export enum ReportHistoryStatus {
    Finished = "Finished",
    Error = "Error",
    Processing = "Processing"
}
